import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Critical Error: 'root' element not found in DOM.");
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <App />
    );
  } catch (error) {
    console.error("React Render Error:", error);
    rootElement.innerHTML = `<div style="padding: 20px; color: red; font-family: sans-serif; background: #fff; position: fixed; inset: 0; z-index: 9999;">
      <h2>Uygulama başlatılamadı</h2>
      <p>Hata Detayı: ${error.message}</p>
      <button onclick="window.location.reload()" style="padding: 10px 20px; background: #f59e0b; color: #fff; border: none; border-radius: 5px; cursor: pointer;">Tekrar Dene</button>
    </div>`;
  }
}
